import { combineReducers } from 'redux';

import { entities } from './entities';
import { errors } from './errors/errors';
import { features } from './features/features';
import { geolocation } from './geolocation/geolocation';
import { isFetching } from './isFetching/isFetching';
import { publicKey } from './publicKey/publicKey';
import { ui } from './ui';

const rootReducer = combineReducers({
  entities,
  errors,
  features,
  geolocation,
  isFetching,
  publicKey,
  ui,
});

export { rootReducer };
